<template>
  <div>
    <div class="nav">
      <button v-bind:class="{selected: nav === 0}" v-on:click="nav = 0">Карточка исходящего обзвона</button>
      <button v-bind:class="{selected: nav === 1}" v-on:click="nav = 1">История</button>
    </div>


    <div v-if="nav === 0" class="border">
      <div class="headBlock fl">

        <div class="leftSide">
          <div class="input_box fl">
            <div>
              <label  class="left">Тип продукта</label>
              <input :readonly="true" v-model="demandData.typeProduct"/>
            </div>
          </div>
          <div class="input_box fl">
            <div>
              <label  class="left">Сумма займа</label>
              <input :readonly="true" v-model="demandData.dlSum"/>
            </div>
          </div>

        </div>

        <div class="rightSide">

          <div class="input_box fl">
            <div>
              <label  class="left">Тип обзвона</label>
              <input :readonly="true" v-model="demandData.typeName"/>
            </div>
          </div>

          <div class="input_box fl">
            <div>
              <label  class="left">ФИО клиента</label>
              <input :readonly="true" v-model="demandData.clientFIO"/>
            </div>
          </div>

          <div class="fl callingBox" id="startCall" v-show="!additionalPhoneFlag">
            <div class="button" v-on:click="startCalling(1)" >Позвонить</div>
            <div style="display: none">{{valueVuex['onlineSimple']['PHONE']}}</div>
            <div class="button" v-on:click="showAdditionalPhone" >Добавить номер телефона</div>
          </div>
          <div v-show="additionalPhoneFlag" class="fl callingBox">
            <formInput :refs="'PHONE'" :form="'onlineSimple'"></formInput>
            <div class="button" v-on:click="startCalling(2)" >Позвонить</div>
          </div>
          <div class="fl callingBox">
            <div class="button" v-on:click="sendSms">Отправить СМС</div>
          </div>

        </div>

      </div>

      <div class="infoTable">
        <div>
          <ul class="result_table finderRequest myrequest">
            <li class="result_head">
              <p>Продукт</p>
              <p>Срок займа (Недели)</p>
              <p>Пск %</p>
              <p>ПСК руб. переплата по займу</p>
              <p>Еженедельный платёж</p>
              <p>Итоговая сумма выплат</p>
            </li>
            <li class="fl">
              <p>{{ demandData.typeProduct }}</p>
              <p>{{ demandData.dlPeriod }}</p>
              <p>{{ demandData.psk }}</p>
              <p>{{ demandData.pskSum }}</p>
              <p>{{ demandData.payFixed }}</p>
              <p>{{ demandData.allSum }}</p>
            </li>
          </ul>
        </div>
      </div>

      <statusBarReason :statusReasonList="demandData.refCallReason"/>

      <statusBarCallStatus :callStatusList="demandData.refCallStatus"/>
    </div>

    <div v-else class="border">
      <div class="infoTable">
        <div>
          <ul class="result_table finderRequest myrequest">
            <li class="result_head">
              <p>Номер заявки</p>
              <p>Дата/Время звонка</p>
              <p>ФИО оператора</p>
              <p>Причина</p>
              <p>Статус</p>
              <p>Комментарий оператора</p>
            </li>
            <li class="fl" v-for="(item, index) in history" :key="index">
              <p>{{ item.demandID }}</p>
<!--              <p>{{ $myFilter.timeFromXtoDateView3(item.datetimeCall) }}</p>-->
              <p>{{ $myFilter.timeFromXtoDateView3(item.datetimeCall) }}</p>
              <p>{{ item.staffFIO }}</p>
              <p>{{ item.reasonName }}</p>
              <p>{{ item.statusName }}</p>
              <p>{{ item.comment }}</p>
            </li>
          </ul>
        </div>
      </div>

    </div>
    <div class="button" v-on:click="saveData">Сохранить</div>







  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import DataForInput from "@/gavnoCode/longFormOptions";
import axios from "axios";

export default {
  name: "detailType1",
  data() {
    return {
      additionalPhoneFlag: false,
      history: [],
      nav: 0,
      demandData: {},
    }
  },
  props: {
    DemandID: {
      type: Number,
      default: 0
    },
  },
  components: {
    formInput: () => import('@/components/forms/formInput'),
    statusBarReason: () => import('@/components/status/statusBarReason'),
    statusBarCallStatus: () => import('@/components/status/statusBarCallStatus'),
  },
  methods: {
    clearStore() {
      this.$store.dispatch('resetToDefault');
    },


    getData() {
      this.clearStore();
      this.$myApi.callSharpApi({
        externalType: 'ms',
        msUrl: 'back-loannp/CallCenter/CC_getSimpleDemandInfo',
        urlType: '',
        method: 'GET',
        UserID: localStorage.getItem('UserID'),
        DemandID: this.DemandID,
      }).then((res) => {
        this.demandData = res;
        this.$store.dispatch('saveSendData', {
          target: 'PHONE',
          form: 'onlineSimple',
          value: res.phone
        });
      }).catch(res => {
        alert(res.Message);
        this.$emit('closeDetails', false);
      })
    },

    getHistory() {
      this.clearStore();
      this.$myApi.callSharpApi({
        externalType: 'ms',
        msUrl: 'back-loannp/CallCenter/CC_SimpleDemandsCallHistory',
        urlType: '',
        method: 'GET',
        UserID: localStorage.getItem('UserID'),
        DemandID: this.DemandID,
      }).then((res) => {
        this.history = res;
      }).catch(res => {
        this.$emit('closeDetails', false);
        alert(res.Message);
      })
    },

    sendSms() {
      this.clearStore();
      this.$myApi.callSharpApi({
        externalType: 'ms',
        msUrl: 'back-loannp/CallCenter/CC_sendSMSSimpleDemand',
        urlType: '',
        method: 'POST',
        UserID: localStorage.getItem('UserID'),
        DemandID: this.DemandID,
      }).then((res) => {
       alert(res);
      }).catch(res => {
        alert(res.Message);
      })
    },
    saveData() {
      if (this.valueVuex.onlineSimple.reasonStatus === 0) {
        alert('не выбрана причина');
        return false
      }

      if (this.valueVuex.onlineSimple.callStatus === 0) {
        alert('не выбран статус звонка');
        return false
      }

      let dataToBack = {
        demandID: this.DemandID,
        comment: this.valueVuex.onlineSimple.OperatorMsg,
        callReasonID: this.valueVuex.onlineSimple.reasonStatus,
        callStatus: this.valueVuex.onlineSimple.callStatus,
        callSubTypeID: this.demandData.typeID
      }

      // console.log(this.valueVuex.onlineSimple.newCallDate.length > 0);
      // console.log(this.valueVuex.onlineSimple.newCallDate.length);
      // console.log(this.valueVuex.onlineSimple.newCallTime.length > 0);
      // console.log(this.valueVuex.onlineSimple.newCallTime.length);
      if (this.valueVuex.onlineSimple.newCallDate.length !== 0 && this.valueVuex.onlineSimple.newCallTime.length !== 0) {
        dataToBack['dtWaitNewCall'] = this.valueVuex.onlineSimple.newCallDate + 'T' + this.valueVuex.onlineSimple.newCallTime;
      }

      this.$myApi.callSharpApi({
        externalType: 'ms',
        msUrl: 'back-loannp/CallCenter/CC_setSimpleDemandCallResult',
        urlType: '',
        method: 'POST',
        UserID: localStorage.getItem('UserID'),
        data: dataToBack
      }).then((res) => {
        this.$emit('closeDetails', true);
        alert(res);
      }).catch(res => {
        alert(res.Message);
      })
    },


    startCalling: function () {
      this.$myApi.singleRequest({
        action:'asterisk_startCall_online',
        phone:this.valueVuex['onlineSimple']['PHONE'],
      }).then((res)=>console.log(res))
          .catch((res)=>console.log(res));
    },
    showAdditionalPhone:function(){
      this.additionalPhoneFlag = true;
    },

  },
  computed: {
    ...mapGetters(['getProduct', 'getAvailableSum', 'getAvailablePeriod', 'getSelectedPskInfo']),
    ...mapState({
      valueVuex: state => state.requestField['sendData'],
    }),

    checkBeforeSave() {
      if (this.valueVuex.onlineSimple.callStatus === 6 ) {
        return ''
      }
    }

  },
  mounted() {
    this.getData();
    this.getHistory();
  },

}
</script>

<style scoped>
.nav { display: flex }
.nav button { cursor: pointer; padding: 6px 10px; font-size: 16px }
.nav button.selected { background-color: rgb(15, 87, 64); color: white }
.border { border: 1px solid #343434; padding: 20px; position: relative; top: -2px; background-color: white }
.headBlock { width: 50% }
.result_table li{display: flex;align-items: stretch;justify-content: start;border:1px solid #c2c2c2;background: rgba(217, 243, 220, 0.52);font-size: 14px;line-height: 1.1;text-transform: lowercase; cursor: pointer}
.result_table li:nth-child(2n){background: white;}
.result_table li p{border-left: 1px solid #c2c2c2;padding: 4px;}
.result_table li p:first-child{border-left: 0 solid #c2c2c2;}

.result_table.finderRequest p:nth-child(1){width: 7%;}
.result_table.finderRequest p:nth-child(2){width: 12%;}
.result_table.finderRequest p:nth-child(3){width: 8%;}
.result_table.finderRequest p:nth-child(4){width: 8%;}
.result_table.finderRequest p:nth-child(5){width: 8%;}
.result_table.finderRequest p:nth-child(6){width: 8%;}
.result_table.finderRequest p:nth-child(7){width: 8%;}
.result_table.finderRequest p:nth-child(8){width: 8%;}
.result_table.finderRequest p:nth-child(9){width: 7%;}
.result_table.finderRequest p:nth-child(10){width: 16%;}

.result_table.finderRequest.myrequest p:nth-child(1){width: 10%;}
.result_table.finderRequest.myrequest p:nth-child(2){width: 10%;}
.result_table.finderRequest.myrequest p:nth-child(3){width: 10%;}
.result_table.finderRequest.myrequest p:nth-child(4){width: 10%;}
</style>
